export const NAMESPACE = 'KanBo/layout/'
export const INIT = NAMESPACE + 'INIT'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_NO_CONNECTION = NAMESPACE + 'SET_NO_CONNECTION'
export const SHOW_PROFILE = NAMESPACE + 'SHOW_PROFILE'
export const SET_IS_SIDEBAR_VISIBLE = NAMESPACE + 'SET_IS_SIDEBAR_VISIBLE'

const initialState = {
  isLoading: false,
  isLoaded: false,
  noConnection: false,
  showProfile: null,
  isSidebarVisible: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case SET_NO_CONNECTION:
      return {
        ...state,
        noConnection: action.payload.noConnection
      }
    case SHOW_PROFILE:
      return {
        ...state,
        showProfile: action.payload.profileKey
      }
    case SET_IS_SIDEBAR_VISIBLE:
      return {
        ...state,
        isSidebarVisible: action.payload.isSidebarVisible
      }
    default: return state
  }
}

export function init (payload = initialState) {
  return {
    type: INIT,
    payload
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function setNoConnection ({ noConnection }) {
  return {
    type: SET_NO_CONNECTION,
    payload: {
      noConnection
    }
  }
}

export function showProfile ({ profileKey }) {
  return {
    type: SHOW_PROFILE,
    payload: {
      profileKey
    }
  }
}

export function setIsSidebarVisible (isSidebarVisible) {
  return {
    type: SET_IS_SIDEBAR_VISIBLE,
    payload: {
      isSidebarVisible
    }
  }
}
